import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { isMobile, isTablet, isDesktop } from 'react-device-detect';
import CONSTS from '../config/constants';
import { setUserProperties } from '../helpers/analytics';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const getDeviceType = () => {
  if (isMobile) return 'mobile';
  if (isTablet) return 'tablet';
  if (isDesktop) return 'desktop';
  return 'unknown';
};

const GoogleAnalytics = () => {
  useEffect(() => {
    if (process.env.REACT_APP_ENV === CONSTS.ENV.PROD && GA_MEASUREMENT_ID) {
      ReactGA.initialize(GA_MEASUREMENT_ID);
      setUserProperties({ device_type: getDeviceType() });
    }
  }, []);

  return null;
};

export default GoogleAnalytics;
